import { Injectable } from "@angular/core";
import { AngularProvidedAction } from "@vega/bridge";

@Injectable()
/**
 * This is a basic implementation of the can-close action that always allows for the Topvis window to be closed
 */
export class CanCloseAction implements AngularProvidedAction<void, boolean> {
    public id = "can-close";

    /**
     * If you also need to check if the form is dirty and save/discard the changes, cancel the closing of the window(return false)
     * and trigger a new event at the end. Check how it is implemented in Product.WebClient to avoid injecting lazy loading modules in root.
     */
    public action(): boolean {
        // return true so that the window can be closed in TopVis
        return true;
    }
}
